import { render, staticRenderFns } from "./study-participant-details.vue?vue&type=template&id=8fba921e&scoped=true&"
import script from "./study-participant-details.vue?vue&type=script&lang=js&"
export * from "./study-participant-details.vue?vue&type=script&lang=js&"
import style0 from "./study-participant-details.vue?vue&type=style&index=0&id=8fba921e&scoped=true&lang=scss&"
import style1 from "./study-participant-details.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fba921e",
  null
  
)

component.options.__file = "study-participant-details.vue"
export default component.exports